// extracted by mini-css-extract-plugin
module.exports = {"debugInfo":"debugInfo_V2RNk","heading":"heading_3qpkX","error":"error_1e3Dw","dataItem":"dataItem_3hpDI","label":"label_3TukY","value":"value_2dniJ"};